/*
* Copyright (C) Regione Lombardia
*/
import { Pipe, PipeTransform } from '@angular/core';
import { AnagraficaTipologiaRilevamento } from '@models';

@Pipe({
    name: 'anagraficaTipologiaRilevamento',
})
export class AnagraficaTipologiaRilevamentoPipe implements PipeTransform {

    transform(value: number, items: AnagraficaTipologiaRilevamento[]) {
        return items.find(i => i.id === value)?.descrizione || '';
    }

}
